import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';

const store = {
  namespaced: true,
  state: {
    currencyIntroductionList: [],
    introductionDetail: {
      coinBlock: 0,
      marketValue: 0,
      introductionDetail: '',
      description: {},
      teamDescription: {},
      competitiveness:{},
      prospects:{},
      currencyIntroductionRwa:{
        stockName:'',
        stockCode:'',
        quotationLink: '',
        vieArch: '',
        competitiveness:{},
        prospects:{}
        },
      currencyIntroductionTeam:[],
      currencyIntroductionStock:[],
      currencyIntroductionStockStack:[]
    },
    detailDialogVisible: false, // 修改页面弹窗
    dialogVisible: false, // 添加页面弹窗
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {},
  mutations: {
    setCurrencyIntroductionList(state, payload) {
      state.currencyIntroductionList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    toggleDetailDialogVisible(state, payload) {
      state.introductionDetail = JSON.parse(JSON.stringify(state.introductionDetail));
      state.detailDialogVisible = payload;
    },
    setIntroductionDetail(state, payload) {
      // state.introductionDetail = payload;
      state.introductionDetail = JSON.parse(JSON.stringify(payload));
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    list({ commit }, { query, page, size }) {
      api
        .getCurrencyIntroductionList({ query, page, size })
        .then(({ data }) => {
          commit('setPagination', { page, size });
          commit('setCurrencyIntroductionList', data);
        });
    },
    detail({ commit }, id) {
      return api.getCurrencyIntroductionDetail(id).then(({ data }) => {
        if(data.currencyIntroductionRwa!=null){
          data.currencyIntroductionRwa.competitiveness = data.currencyIntroductionRwa.competitiveness ? JSON.parse(data.currencyIntroductionRwa.competitiveness) : {},
              data.currencyIntroductionRwa.prospects = data.currencyIntroductionRwa.prospects
                  ? JSON.parse(data.currencyIntroductionRwa.prospects)
                  : {};
        }

        commit('setIntroductionDetail', {
          ...data,
          description: data.description ? JSON.parse(data.description) : {},
          teamDescription: data.teamDescription
            ? JSON.parse(data.teamDescription)
            : {},
        });
      });
    },
    create(context, introduction) {
      return api.createCurrencyIntroduction(introduction);
    },
    update(context, introduction) {
      // console.log(JSON.stringify(introduction.currencyIntroductionRwa.competitiveness));
      // TODO 暂时注掉，用于调试
      return api.updateCurrencyIntroduction(introduction);
    },
    remove(context, id) {
      return api.removeCurrencyIntroduction(id);
    }
  }
};

appStore.registerModule('currencyIntroductionSetting', store);
